/**
 *
 * @param min included
 * @param max excluded
 * @returns random digit between two numbers
 */
export const generateRandomDigit = (min: number, max: number): number => {
  return Math.floor(Math.random() * (max - min)) + min;
};
